'use strict';

module.exports = require('./google-tag-manager');


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-beacon/targets/google-tag-manager/index.js
// module id = 680
// module chunks = 0 1